import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Stepper, Step, StepLabel, Button, RadioGroup, FormControlLabel, Radio, CircularProgress, TextField } from '@material-ui/core';
import { BASE_URL } from '../../../store/config';
import instance from '../../../request/http';
import { roleStr, ADD, EDIT, VIEW } from '../../../common/common';
import Toast from '../../Layout/components/Toast';
import UserAutoComplete from '../../Components/UserAutoComplete';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .page-title': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginTop: '18px',
    },
    '& .text-field': {
        width: '100%',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#F3F3F3',
        margin: '20px 0',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginLeft: '10px',
        },
    },
})

class TaskInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            desc: '',
            user_ids: '',
            principals: '',
            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.updateMember = this.updateMember.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    render() {
        const { title, data, state } = this.props;
        const {
            name,
            desc,
            user_ids,
            principals,
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        const btns = () => {
            if (state !== VIEW) {
                return <Button
                    className="btn"
                    variant="contained"
                    color="primary"
                    onClick={this.handleCreate}
                >
                    {state === ADD ? 'create' : 'save'}
                </Button>
            }
        }
        return (
            <Root>
                <div className="page-title">{title}</div>
                <div className="line"></div>
                <div className="title">Task Name</div>
                <TextField
                    disabled={this.isDisabled()}
                    className="text-field"
                    label='Task Name'
                    required
                    value={name}
                    margin="dense"
                    variant="outlined"
                    onChange={e => this.handleChange(e, 'name')}
                />
                <div className="title">Task desc</div>
                <TextField
                    disabled={this.isDisabled()}
                    className="text-field"
                    label='Task desc'
                    value={desc}
                    onChange={e => this.handleChange(e, 'desc')}
                    margin="dense"
                    multiline
                    rows="4"
                    variant="outlined"
                />
                <div className="title">Principal</div>
                <UserAutoComplete
                    disabled={this.isDisabled()}
                    initUser={this.getUser()}
                    update={this.updateMember}
                />
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button variant="contained" onClick={this.handleClose}>CANCEL</Button>
                    {btns()}
                </div>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        const { state, data } = this.props;
        if (state !== ADD) {
            if (data) {
                this.setState({
                    name: data.name,
                    desc: data.desc,
                })
            }
        }
    }
    getUser() {
        const { data } = this.props;
        if (!data) return null;
        if (!data.principals) return null;
        if (data.principals.length <= 0) return null;
        return data.principals[0];
    }
    updateMember(member) {
        console.log('mmmmm', member)
        if (!member) return;
        const user_ids = [];
        user_ids.push(member.id);
        this.setState({
            user_ids
        })
    }
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleCreate() {
        const { name, desc, user_ids } = this.state;
        const isPass = this.verifyData(name, user_ids);
        if (isPass) {
            this.props.handleCreate(name, desc, user_ids);
        }
    }
    verifyData(name, user_ids) {
        let isPass = true;
        if (!name) {
            this.showToast("Please fill in the name", "warning");
            isPass = false;
        } else if (user_ids.length <= 0) {
            this.showToast("Please choose a principal", "warning");
            isPass = false;
        }
        return isPass;
    }
    handleClose() {
        this.props.handleCancel();
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    //------------request-----------------
}

export default TaskInfo;